var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Mutex } from 'async-mutex';
import { loginRequest } from '../../../auth-config';
import { msalInstance } from '../../../index';
import i18n from '../../../localization/i18next';
import { RoleCategories } from '../../common/constants/role-categories';
import { setCurrentUser } from '../auth/authSlice';
var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
var mutex = new Mutex();
var baseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: function (headers, api) {
        return __awaiter(this, void 0, void 0, function () {
            var formDataEndPoints, binaryEndPoints, token;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        formDataEndPoints = [
                            'createMachineDocument',
                            'createAndLinkMachine',
                            'createCompany',
                            'updateCompany'
                        ];
                        binaryEndPoints = ['analyzeImage'];
                        return [4 /*yield*/, getSilentToken()];
                    case 1:
                        token = _b.sent();
                        if (binaryEndPoints.includes(api.endpoint))
                            headers.set('Content-Type', 'application/octet-stream');
                        else if (!formDataEndPoints.includes(api.endpoint))
                            headers.append('Content-Type', 'application/json');
                        headers.append('Authorization', "Bearer ".concat(token));
                        headers.append('XAuthorization', "Bearer ".concat(localStorage.getItem('AccessToken')));
                        headers.append('Accept-Language', (_a = i18n.language) !== null && _a !== void 0 ? _a : 'en');
                        return [2 /*return*/];
                }
            });
        });
    }
});
var baseQueryWithReauth = function (args, api, extraOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var companyId, currentUser, tokenExcludedEndPoints, companyIdExcludedEndPoints, resolvedCompanyId, isSuperAdmin, companyIdExcluded, addCompanyIdToRequest, isBinaryBody, result, release, response, loginResponse;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                companyId = (_a = api.getState().common.currentCompany) === null || _a === void 0 ? void 0 : _a.id;
                currentUser = api.getState().auth.currentUser;
                tokenExcludedEndPoints = ['getCurrentUser', 'getToken'];
                companyIdExcludedEndPoints = [
                    'getConversations',
                    'getConversation',
                    'getAnswer',
                    'getActiveMachinesList',
                    'analyzeImage'
                ];
                resolvedCompanyId = companyId !== null && companyId !== void 0 ? companyId : currentUser === null || currentUser === void 0 ? void 0 : currentUser.primaryCompanyId;
                isSuperAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin;
                companyIdExcluded = companyIdExcludedEndPoints.includes(api.endpoint);
                addCompanyIdToRequest = !isSuperAdmin && !companyIdExcluded;
                return [4 /*yield*/, mutex.waitForUnlock()];
            case 1:
                _c.sent();
                if (typeof args === 'string')
                    args = { url: args };
                isBinaryBody = typeof args !== 'string' &&
                    (args.body instanceof ArrayBuffer ||
                        (typeof Blob !== 'undefined' && args.body instanceof Blob));
                if (addCompanyIdToRequest && !isBinaryBody) {
                    if (args.method && args.method === 'POST') {
                        if (args.body instanceof FormData)
                            args.body.append('companyId', resolvedCompanyId !== null && resolvedCompanyId !== void 0 ? resolvedCompanyId : '');
                        else if (args.body && typeof args.body === 'object')
                            args.body = __assign(__assign({}, args.body), { companyId: resolvedCompanyId });
                    }
                    else if (args.params) {
                        args.params.companyId = resolvedCompanyId;
                    }
                    else {
                        args.params = { companyId: resolvedCompanyId };
                    }
                }
                return [4 /*yield*/, baseQuery(args, api, extraOptions)];
            case 2:
                result = _c.sent();
                if (!(!tokenExcludedEndPoints.includes(api.endpoint) && ((_b = result.error) === null || _b === void 0 ? void 0 : _b.status) === 401)) return [3 /*break*/, 12];
                if (!mutex.isLocked()) return [3 /*break*/, 5];
                return [4 /*yield*/, mutex.waitForUnlock()];
            case 3:
                _c.sent();
                return [4 /*yield*/, baseQuery(args, api, extraOptions)];
            case 4:
                result = _c.sent();
                return [3 /*break*/, 12];
            case 5: return [4 /*yield*/, mutex.acquire()];
            case 6:
                release = _c.sent();
                _c.label = 7;
            case 7:
                _c.trys.push([7, , 11, 12]);
                return [4 /*yield*/, baseQuery({ url: 'Account/token', method: 'GET' }, api, extraOptions)];
            case 8:
                response = _c.sent();
                if (!response.data) return [3 /*break*/, 10];
                loginResponse = response.data;
                api.dispatch(setCurrentUser(loginResponse.currentUser));
                localStorage.setItem('AccessToken', loginResponse.accessToken);
                return [4 /*yield*/, baseQuery(args, api, extraOptions)];
            case 9:
                result = _c.sent();
                _c.label = 10;
            case 10: return [3 /*break*/, 12];
            case 11:
                release();
                return [7 /*endfinally*/];
            case 12: return [2 /*return*/, result];
        }
    });
}); };
export var monteurApi = createApi({
    reducerPath: 'monteurApi',
    baseQuery: baseQueryWithReauth,
    endpoints: function () { return ({}); },
    tagTypes: ['Users', 'Roles', 'AllClients', 'FolderView', 'ModelFolder', 'OtherFolder']
});
var getSilentToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var account, authResult, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                account = msalInstance.getActiveAccount();
                if (!account) return [3 /*break*/, 4];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, msalInstance.acquireTokenSilent(__assign(__assign({}, loginRequest), { account: account }))];
            case 2:
                authResult = _a.sent();
                return [2 /*return*/, authResult.accessToken];
            case 3:
                error_1 = _a.sent();
                if (error_1 instanceof InteractionRequiredAuthError) {
                    return [2 /*return*/, msalInstance.acquireTokenRedirect(loginRequest)];
                }
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
